export const translations = {
	'Asset information successfully saved.': {
		no: 'Ressursinnstillinger er lagret',
	},
	'Please complete all required fields.': {
		no: 'Vennligst fyll inn alle felt ',
	},
	'Invalid time': {
		no: 'Ugyldig tid',
	},
	'Select a value...': {
		no: 'Velg verdi...',
	},
	'System type': {
		no: 'Systemtype',
	},
	'There are no assetgroups': {
		no: 'Det er ingen ressursgruppe',
	},
	'Assets successfully deleted.': {
		no: 'Ressursene er slettet',
	},
	'Windows': {
		no: 'Windows',
	},
	'Unix': {
		no: 'Unix',
	},
	'Asset type': {
		no: 'Ressurstype',
	},
	'External type': {
		no: 'Ekstern type',
	},
	'Last update': {
		no: 'Sist oppdatert',
	},
	'Create incident': {
		no: 'Lag sak',
	},
	'Create filter': {
		no: 'Opprett filter',
	},
	'Reset healthindex': {
		no: 'Tilbakestill helseindeks',
	},
	'Historic mode': {
		no: 'Historisk visning',
	},
	'Monitortype': {
		no: 'Monitortype',
	},
	'Monitorclass': {
		no: 'Monitorklasse',
	},
	'Agent name': {
		no: 'Agentnavn',
	},
	'External id': {
		no: 'Ekstern id',
	},
	'Service element': {
		no: 'Tjenesteelement',
	},
	'Assetgroup is EXTERNAL.  It cannot be removed manually. It is deleted when its monitor is deleted.': {
		no: "Denne ressursen er EXTERNAL. Den kan ikke fjernes manuelt, men må fjernes via gruppen's monitoren.",
	},
	'Assetgroup is DYNAMIC.  It cannot be removed manually. It has to be removed by filtersetting in the assetgroup.': {
		no: "Denne ressursen er DYNAMIC. Den kan ikke fjernes manuelt, men må fjernes via gruppen's filterinnstillinger.",
	},
	'Choose an assetgroup...': {
		no: 'Velg en ressursgruppe... ',
	},
	'Assetgroup is of type': {
		no: 'Denne ressursegrupper er av typen',
	},
	'and cannot be removed manually': {
		no: 'og kan ikke fjernes manuellt',
	},
	'Select state': {
		no: 'Velg tilstand',
	},
	'Event was successfully unassigned': {
		no: 'Hendelsen fjernet fra tildeling',
	},
	'Healthreason was successfully removed': {
		no: 'HelseÅrsaken ble fjernet',
	},
	'Healthreasons were successfully removed': {
		no: 'HelseÅrsakene ble fjernet',
	},
	'Information field successfully updated': {
		no: 'Informasjonsfelt er oppdatert',
	},
	'Please, input the asset name.': {
		no: 'Skriv inn navn på ressurs',
	},
	'Start service': {
		no: 'Start tjeneste',
	},
	'Stop service': {
		no: 'Stopp tjeneste',
	},
	'Identifier name': {
		no: 'Identifikator navn',
	},
	'Identifier instance': {
		no: 'Identifikator instans',
	},
	'Event was successfully assigned': {
		no: 'Hendelsen ble tildelt',
	},
	'Select severity:': {
		no: 'Velg alvorlighet:',
	},
	'Healthreason are acknowledged': {
		no: 'HelseÅrsaker er bekreftet',
	},
	'Healthreason for asset #=assetName# are acknowledged': {
		no: 'HelseÅrsak(er) for ressurs #=assetName# er bekreftet',
	},
	'Healthreason are unacknowledged': {
		no: 'HelseÅrsaker er ubekreftet',
	},
	'Healthreason for asset #=assetName# are unacknowledged': {
		no: 'HelseÅrsak(er) for ressurs #=assetName# er ubekreftet',
	},
	'Select asset': {
		no: 'Velg ressurs',
	},
	'We have 3 dependency types for asset <br/>Soft: Asset is removed from monitor or/and application (Note that asset shape is left in application view and must be removed manually in application designer)<br/>HARD: Monitor or servicequalifier is deleted when asset is deleted.<br/>MANUAL: Asset must manually be removed by user from monitor configuration.':
		{
			no: 'Vi har 3 avhengighetstyper for ressurs<br/>Soft: Ressursen fjernes fra monitor eller/og applikasjon (Merk at ressursformen ikke fjernes fra  applikasjonsvisningen og må fjernes manuelt i applikasjonsdesigneren)<br/>HARD: Monitor eller tjenestepunkt blir slettet når ressursen.<br/>MANUAL: Ressurs fjernes manuelt av brukeren fra monitorkonfigurasjon',
		},
	'Assets successfully added to assetgroup': {
		no: 'Ressurser lagt til gruppe',
	},
	'Update assetgroup': {
		no: 'Oppdater ressursgruppe',
	},
	'System monitor console': {
		no: 'System monitorkonsoll',
	},
	'IBM Monitor Console': {
		no: 'IBM Monitor Konsoll',
	},
	'Maintenance period ended': {
		no: 'Vedlikeholdsperiode avsluttet',
	},
	'This is an agent asset and can not be deleted. Remove the agent and try again...': {
		no: 'Dette er en agent ressurs og kan ikke slettes. Fjern agenten først og prøv igjen...',
	},
	'Maintenance period successfully saved.': {
		no: 'Vedlikeholdsperioden er lagret.',
	},
	'Assign in progress': {
		no: 'Tildeling pågår',
	},
	'All is OK': {
		no: 'Alt er OK',
	},
	'No connection to agent, unable to fetch latest healthreason': {
		no: 'Ingen kontakt med agent, klarte ikke å hente siste helseårsaker',
	},
	'The selected health reasons were successfully assigned': {
		no: 'HelseÅrsakene er tildelt',
	},
	'Complete at least one field': {
		no: 'Fyll inn felt',
	},
	'Healthreason filter': {
		no: 'HelseÅrsaksfilter',
	},
	'Leading/trailing whitespace(s) in string': {
		no: 'Strengen begynner/avsluttes med mellomrom',
	},
	'You must add an account': {
		no: 'Du må legge til en konto',
	},
	'All subaccounts selected': {
		no: 'Alle underkontoer er valgt',
	},
	'All subaccounts and current account selected': {
		no: 'Alle underkontoer og gjeldende konto er valgt',
	},
	'Are you sure you want to remove filters?': {
		no: 'Vil du slette filterene?',
	},
	'Are you sure you want to remove filter?': {
		no: 'Vil du slette filter?',
	},
	'Filter successfully deleted': {
		no: 'Filter er slettet',
	},
	'Filter successfully updated.': {
		no: 'Filter er opprettet',
	},
	'Are you sure you want to remove monitors?': {
		no: 'Vil du slette monitor?',
	},
	'Are you sure you want to remove monitor?': {
		no: 'Vil du slette monitor?',
	},
	'Monitor successfully deleted': {
		no: 'Monitor er slettet',
	},
	'Please remove the monitor ${name} from the following items before deleting': {
		no: 'Monitor ${name} må fjernes fra følgende elementer før den kan slettes',
	},
	'Create new asset': {
		no: 'Opprett ny ressurs',
	},
	'Create asset': {
		no: 'Lag ressurs',
	},
	'Create new target for selected asset': {
		no: 'Opprett nytt ressursmål for valgt ressurs',
	},
	'Create authentication': {
		no: 'Opprett autentisering',
	},
	'Optional, provide a meaningful description for the purpose of the monitor': {
		no: 'Valgfritt, gi en fornuftig beskrivelse av hva monitoren skal gjøre',
	},
	'Select asset...': {
		no: 'Velg ressurs... ',
	},
	'Select assetgroup...': {
		no: 'Velg ressursgruppe...',
	},
	'Please fill the required fields': {
		no: 'Vennligst fyll ut alle felt',
	},
	'Please input name...': {
		no: 'Skriv inn navn...',
	},
	'Select assettarget...': {
		no: 'Velg ressursmål...',
	},
	'Operand': {
		no: 'Operand',
	},
	'Rule name already exists': {
		no: 'Regelnavn er i bruk',
	},
	'Metric': {
		no: 'Metrikk',
	},
	'Expected value': {
		no: 'Forventet verdi',
	},
	'Please set asset in all profiles': {
		no: 'Sett ressurs i alle profiler',
	},
	'No data available': {
		no: 'Data ikke tilgjengelig',
	},
	'Agent Error': {
		no: 'Agent Feil',
	},
	'Monitor data unavailable': {
		no: 'Overvåk data utilgjengelig',
	},
	'Monitor successfully created': {
		no: 'Monitor er opprettet',
	},
	'Monitor successfully updated': {
		no: 'Monitor er oppdatert',
	},
	'Add to selected monitorgroup': {
		no: 'Legg til valgt monitor gruppe',
	},
	'Move to...': {
		no: 'Flytt til...',
	},
	'Enter group name': {
		no: 'Sett inn navn på gruppe',
	},
	'Group name is already in use': {
		no: 'Sett inn navn på gruppe',
	},
	'Input monitor name': {
		no: 'Skriv inn monitornavn',
	},
	'Command line': {
		no: 'Kommandolinje',
	},
	'Memory usage': {
		no: 'Brukt minne',
	},
	'There is no data available.': {
		no: 'Ingen data tilgjengelig.',
	},
	'Services': {
		no: 'Tjenester',
	},
	'Started': {
		no: 'Kjører',
	},
	'Delete operating time': {
		no: 'Slett driftstid',
	},
	'Are you sure you want to delete period?': {
		no: 'Er du sikker på at du vil slette denne perioden?',
	},
	'Physical memory': {
		no: 'Fysisk minne',
	},
	'Targets': {
		no: 'Mål',
	},
	'System health': {
		no: 'System helse',
	},
	'CPU total': {
		no: 'Total CPU',
	},
	'No health data': {
		no: 'Ingen helse data',
	},
	'No memory usage data': {
		no: 'Ingen minnebruk data',
	},
	'No CPU total data': {
		no: 'Ingen CPU data',
	},
	'Free space': {
		no: 'Ledig diskplass',
	},
	'Used space': {
		no: 'Brukt diskplass',
	},
	'No data for disk': {
		no: 'Ingen disk data',
	},
	'Select account': {
		no: 'Velg konto',
	},
	'Select monitor': {
		no: 'Velg monitor',
	},
	'Start value for gauge': {
		no: 'Start verdi for måler',
	},
	'Maximum value for gauge': {
		no: 'Maksimum verdi for måler',
	},
	'Values above is rendered red': {
		no: 'Verdier over dette er farget rødt',
	},
	'When enable the breach value will render the area below breach value red. If disabled the area above breach value will be rendered red.':
		{
			no: 'Hvis inverter er aktiv så vil verdier under brudd verdi være rødt. Inaktiv vil si at verdier over brudd verdi er rødt',
		},
	'Select monitortype': {
		no: 'Velg monitortype',
	},
	'Input a numeric value for min': {
		no: 'Sett inn numerisk verdi for minimum',
	},
	'Input a numeric value for breach': {
		no: 'Sett inn numerisk verdi for brudd',
	},
	'Input a numeric value for max': {
		no: 'Sett inn numerisk verdi for maksimum',
	},
	'Breach value should not be greater than maximum value': {
		no: 'Brudd verdien kan ikke være større enn maksimum verdien',
	},
	'Min value should not be greater than maximum value': {
		no: 'Minimum verdi må ikke være større enn maksimum',
	},
	'Select value in missing fields': {
		no: 'Sett verdi i ufullstendige felter',
	},
	'Select value in missing field': {
		no: 'Sett verdi i ufullstendig felt',
	},
	'Column visibility': {
		no: 'Kolonne visning',
	},
	'Further zoom is not possible': {
		no: 'Videre zoom er ikke mulig',
	},
	'Period': {
		no: 'Periode',
	},
	'Missing data will be represented with a grey field': {
		no: 'Manglende data vil bli vist med et grått felt',
	},
	'No monitors': {
		no: 'Ingen monitorer',
	},
	'Select servicequalifier': {
		no: 'Velg tjenestepunkt',
	},
};
